/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1MylibraryPeople202,
  DeleteApiV1MylibraryPeople400,
  DeleteApiV1MylibraryPeople401,
  DeleteApiV1MylibraryPeople500,
  DeleteApiV1MylibraryPeopleMutationRequest,
  DeleteApiV1MylibraryPeopleMutationResponse,
} from "../../types/myLibraryManutenoController/DeleteApiV1MylibraryPeople.ts";
import { deleteMyLibraryPeopleRequestViewModelSchema } from "../deleteMyLibraryPeopleRequestViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1MylibraryPeople202Schema =
  z.boolean() as unknown as ToZod<DeleteApiV1MylibraryPeople202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1MylibraryPeople400Schema =
  z.any() as unknown as ToZod<DeleteApiV1MylibraryPeople400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1MylibraryPeople401Schema =
  z.any() as unknown as ToZod<DeleteApiV1MylibraryPeople401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1MylibraryPeople500Schema =
  z.any() as unknown as ToZod<DeleteApiV1MylibraryPeople500>;

export const deleteApiV1MylibraryPeopleMutationRequestSchema = z.lazy(
  () => deleteMyLibraryPeopleRequestViewModelSchema,
) as unknown as ToZod<DeleteApiV1MylibraryPeopleMutationRequest>;

export const deleteApiV1MylibraryPeopleMutationResponseSchema = z.lazy(
  () => deleteApiV1MylibraryPeople202Schema,
) as unknown as ToZod<DeleteApiV1MylibraryPeopleMutationResponse>;
